import React from 'react';

const UserInfo = ({ email, onLogout }) => {
  if (!email) return null;

  return (
    <div className="user-info">
      <span className="user-email">{email}</span>
      <button 
        className="logout-button"
        onClick={onLogout}
        title="Logout"
      >
        🚪 Logout
      </button>
    </div>
  );
};

export default UserInfo;
